import { render, staticRenderFns } from "./index.vue?vue&type=template&id=67a63cbc&"
import script from "./footerbar.js?vue&type=script&lang=js&"
export * from "./footerbar.js?vue&type=script&lang=js&"
import style0 from "./footerbar.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports